import {MicaProductList} from '../../types/interfaces/configuration';


export class FetchMicaProduct {
  static readonly type = '[micaProduct] Fetch All';

  constructor(public payload: MicaProductList[]) {
  }
}
